import styled from 'styled-components';

export const Container = styled.div`
  margin: 0 auto;
  width: 92vw;
  min-height: 100vh;
  max-width: 1440px;
`;
